import { useSelector } from 'react-redux'
import { BotFeatures } from '@feedyou/schema'
import questionStepSchema from '@feedyou/schema/schema/steps/question.json'

import { isAttachmentEnabledForQuestionStep } from '../../../utils/utils'
import { useBaseSchema, removeConditionPropsFromSchema } from '../../../../../../features/schema'
import { isStepNlpEnabledSelector } from '../../../../../../store/flow/selectors/isStepNlpEnabledSelector'

export function useFormSchema(sdkFeatures: BotFeatures[] = []) {
  const schema = useBaseSchema(questionStepSchema)
  const isStepNlpEnabled = useSelector(isStepNlpEnabledSelector)

  delete schema?.properties?.answers
  delete schema?.properties?.defaultAnswer

  if (!isAttachmentEnabledForQuestionStep(sdkFeatures)) {
    delete schema?.properties?.attachment
  }

  if (!isStepNlpEnabled && schema?.properties) {
    delete schema.properties.nlpConfigurationId
  }

  return removeConditionPropsFromSchema(schema, sdkFeatures)
}
